// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"05ddb161","425":"7a46fcb9","510":"f0bf6eba","532":"414d80e7","633":"22d80f26","634":"d2e7cc32","922":"96960216","937":"91e77895","972":"d6f801b4"}[chunkId] + ".chunk.js";
};